require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./listdropdown"), require("./progressindicator"), require("./searchinput"), require("./utils"));
	else if(typeof define === 'function' && define.amd)
		define(["./listdropdown", "./progressindicator", "./searchinput", "./utils"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./listdropdown"), require("./progressindicator"), require("./searchinput"), require("./utils")) : factory(root["./listdropdown"], root["./progressindicator"], root["./searchinput"], root["./utils"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(globalThis, (__WEBPACK_EXTERNAL_MODULE__57756__, __WEBPACK_EXTERNAL_MODULE__3142__, __WEBPACK_EXTERNAL_MODULE__16293__, __WEBPACK_EXTERNAL_MODULE__78815__) => {
return (globalThis["wpBaUiCarbonToolkit"] = globalThis["wpBaUiCarbonToolkit"] || []).push([[3137],{

/***/ 42240:
/***/ ((module) => {

var amdi18n={"__root":{"autoCompleteSearchInput":"auto complete search input"},"__cs":{"autoCompleteSearchInput":"vstup vyhledávání s automatickým dokončováním"},"__da":{"autoCompleteSearchInput":"automatisk fuldførelse af søgeinput"},"__de":{"autoCompleteSearchInput":"Sucheingabe automatisch vervollständigen"},"__es":{"autoCompleteSearchInput":"autocompletar entrada de búsqueda"},"__fi":{"autoCompleteSearchInput":"Automaattinen hakusyöttö"},"__fr":{"autoCompleteSearchInput":"entrée pour la recherche par saisie semi-automatique"},"__hr":{"autoCompleteSearchInput":"automatska dopuna ulaza za pretraživanje"},"__hu":{"autoCompleteSearchInput":"keresési bevitel automatikus kiegészítése"},"__it":{"autoCompleteSearchInput":"completa automaticamente l'input per la ricerca"},"__ja":{"autoCompleteSearchInput":"オートコンプリート検索入力"},"__kk":{"autoCompleteSearchInput":"авто аяқтау іздеуін енгізу"},"__ko":{"autoCompleteSearchInput":"자동 완성 검색 입력"},"__nb":{"autoCompleteSearchInput":"søketekst med automatisk utfylling"},"__nl":{"autoCompleteSearchInput":"invoer voor zoeken automatisch voltooien"},"__no":{"autoCompleteSearchInput":"søketekst med automatisk utfylling"},"__pl":{"autoCompleteSearchInput":"automatyczne uzupełnianie danych wejściowych wyszukiwania"},"__pt":{"autoCompleteSearchInput":"entrada de procura de preenchimento automático"},"__pt-br":{"autoCompleteSearchInput":"entrada de procura de preenchimento automático"},"__ro":{"autoCompleteSearchInput":"completare automată intrare de căutare"},"__ru":{"autoCompleteSearchInput":"автозаполнение ввода поиска"},"__sl":{"autoCompleteSearchInput":"samodejno dokončanje iskalnega vnosa"},"__sv":{"autoCompleteSearchInput":"indata automatisk sökning"},"__th":{"autoCompleteSearchInput":"อินพุตการค้นหาแบบสมบูรณ์โดยอัตโนมัติ"},"__tr":{"autoCompleteSearchInput":"Arama girişini otomatik tamamla"},"__uk":{"autoCompleteSearchInput":"автоматичне завершення пошукового запиту"},"__zh":{"autoCompleteSearchInput":"自动完成搜索输入"},"__zh-cn":{"autoCompleteSearchInput":"自动完成搜索输入"},"__zh-hk":{"autoCompleteSearchInput":"自動完成搜尋輸入"},"__zh-mo":{"autoCompleteSearchInput":"自動完成搜尋輸入"},"__zh-sg":{"autoCompleteSearchInput":"自动完成搜索输入"},"__zh-tw":{"autoCompleteSearchInput":"自動完成搜尋輸入"}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;

/***/ }),

/***/ 84774:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(__webpack_require__(38213));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(68779));
var _react = _interopRequireWildcard(__webpack_require__(16689));
var _propTypes = _interopRequireDefault(__webpack_require__(580));
var _reactDom = __webpack_require__(66405);
var _utils = __webpack_require__(78815);
var _searchinput = _interopRequireDefault(__webpack_require__(16293));
var _progressindicator = _interopRequireDefault(__webpack_require__(3142));
var _listdropdown = _interopRequireDefault(__webpack_require__(57756));
var _AutoCompleteInput = _interopRequireDefault(__webpack_require__(32498));
var _StringResource = _interopRequireDefault(__webpack_require__(8796));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2022
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

const {
  startsWithFilter,
  containsFilter
} = _utils.arrayFilters;
const autoCompleteInputClassName = _AutoCompleteInput.default.autoCompleteInputClassName.replace(/"/g, '');
const {
  sanitize,
  getInheritedProps
} = _utils.propsUtils;
const {
  getKeyName,
  keyNames
} = _utils.keyboardUtils;
const {
  get,
  uniqueId,
  isEqual
} = _utils.lodash;
class AutoCompleteInput extends _react.Component {
  constructor(props) {
    super(props);
    (0, _defineProperty2.default)(this, "onSelectionChange", (val, name, index) => {
      this._onSelectionChange(index, true);
    });
    (0, _defineProperty2.default)(this, "_onActiveChange", index => {
      this.setState(state => ({
        focusIndex: index,
        value: this._getStringValue(state.filteredValues[index])
      }));
    });
    (0, _defineProperty2.default)(this, "_onSubmit", v => {
      let value;
      const currentStringValue = this.state.value;
      if (v) {
        value = v;
      } else if (this._arrayContainsObj(this.props.values)) {
        value = {
          value: currentStringValue,
          label: currentStringValue
        };
      } else {
        value = currentStringValue;
      }
      this.props.onSubmit && this.props.onSubmit(value);
    });
    (0, _defineProperty2.default)(this, "_onSelectionChange", (index, submit) => {
      if (index >= 0) {
        const {
          filteredValues
        } = this.state;
        const value = filteredValues[index];
        this.setState({
          open: false,
          focusIndex: -1,
          value: this._getStringValue(value)
        });

        // expose string or object in callbacks
        this.props.onSelectionChange && this.props.onSelectionChange(value);
        submit && this._onSubmit(value);
      }
    });
    (0, _defineProperty2.default)(this, "_onKeyDown", e => {
      const {
        focusIndex
      } = this.state;
      const {
        filteredValues
      } = this.state;
      const {
        SHIFT,
        ESCAPE,
        A,
        HOME,
        UP,
        DOWN,
        ENTER,
        SPACE
      } = keyNames;
      if (this.state.open) {
        switch (getKeyName(e)) {
          case SHIFT:
            break;
          case HOME:
            e.preventDefault();
            if (filteredValues && filteredValues.length) {
              const newFocusIndex = 0;
              this.setState({
                focusIndex: newFocusIndex,
                value: this._getStringValue(filteredValues[newFocusIndex])
              });
            }
            break;
          case UP:
            e.preventDefault();
            if (filteredValues && filteredValues.length) {
              if (focusIndex === 0) {
                this.setState({
                  focusIndex: -1,
                  value: this._getStringValue(this.props.value)
                });
              } else if (focusIndex === -1) {
                const newFocusIndex = filteredValues.length - 1;
                this.setState({
                  focusIndex: newFocusIndex,
                  value: this._getStringValue(filteredValues[newFocusIndex])
                });
              } else {
                this._handleKeyEventByList(e);
              }
            }
            break;
          case DOWN:
            e.preventDefault();
            if (filteredValues && filteredValues.length) {
              if (focusIndex === filteredValues.length - 1) {
                this.setState({
                  focusIndex: -1,
                  value: this._getStringValue(this.props.value)
                });
              } else if (focusIndex === -1) {
                this.setState({
                  focusIndex: 0,
                  value: this._getStringValue(filteredValues[0])
                });
              } else {
                this._handleKeyEventByList(e);
              }
            }
            break;
          case ESCAPE:
            e.preventDefault();
            this.setState({
              open: false,
              focusIndex: -1,
              value: ''
            });
            break;
          case SPACE:
            if (focusIndex !== -1) {
              this._onSelectionChange(focusIndex);
            }
            break;
          case A:
            // override key event handler for e.ctrlKey || e.metaKey in List.js
            break;
          case ENTER:
            if (focusIndex === -1) {
              // Defect BAUICOMMON-823: trigger _onSelectionChange if input value is equal to filtered value
              if (filteredValues.length && this.state.value === filteredValues[0]) {
                this._onSelectionChange(0);
              }
              this._onSubmit();
              this.setState({
                open: false
              });
              break;
            }
          // falls through
          default:
            this._handleKeyEventByList(e);
        }
      } else {
        switch (getKeyName(e)) {
          case ENTER:
            this._onSubmit();
            break;
          case ESCAPE:
            e.preventDefault();
            this.setState({
              focusIndex: -1,
              value: ''
            });
            break;
          case UP:
          // falls through
          case DOWN:
            // arrow down
            e.preventDefault();
            this.setState({
              open: true
            });
            break;
          case SPACE:
            if (e.ctrlKey) {
              e.preventDefault();
              this.setState({
                open: true
              });
            }
            break;
          default:
        }
      }
      this.props.onKeyDown && this.props.onKeyDown(e);
    });
    (0, _defineProperty2.default)(this, "_onChange", value => {
      const {
        values
      } = this.props;
      this._notifyChange(value);
      const hasFilteredValues = this._hasFilteredValues(value, values);
      this.setState({
        open: hasFilteredValues,
        value: this._getStringValue(value)
      });
    });
    (0, _defineProperty2.default)(this, "_onBlur", e => {
      // Defect 229379: Prevent dropdown from closing when user clicks on scroll arrow buttons
      const listNode = get(this, '_dropdown._list._node');
      if (listNode && (listNode.contains(document.activeElement) || listNode.contains(e.relatedTarget)) || e.target !== e.currentTarget) {
        this.focus();
        return;
      }
      if (this.state.open) {
        this.setState({
          open: false
        });
      }
      this.props.onBlur && this.props.onBlur(e);
    });
    (0, _defineProperty2.default)(this, "_triggerNodeRenderer", ref => {
      const {
        id,
        // eslint-disable-line @typescript-eslint/no-unused-vars
        'data-tid': dataTid,
        // eslint-disable-line @typescript-eslint/no-unused-vars
        fullWidth,
        // eslint-disable-line @typescript-eslint/no-unused-vars
        iconLeft,
        // eslint-disable-line @typescript-eslint/no-unused-vars
        hideLeftIcon,
        // eslint-disable-line @typescript-eslint/no-unused-vars
        ariaLabelledBy,
        loading,
        progressIndicatorExtraOptions,
        ...others
      } = this.props;
      const autocompleteIcon = loading && !hideLeftIcon ? /*#__PURE__*/_react.default.createElement(_progressindicator.default, (0, _extends2.default)({
        "data-tid": "ba-auto-complete__progress-indicator"
      }, sanitize(progressIndicatorExtraOptions, AutoCompleteInput), {
        variant: "circle",
        tabIndex: -1,
        size: "small"
      })) : iconLeft;
      const {
        value
      } = this.state;
      const searchInputPassthroughProps = getInheritedProps(others, _searchinput.default);
      return /*#__PURE__*/_react.default.createElement(_searchinput.default, (0, _extends2.default)({
        ariaLabelledBy: ariaLabelledBy // pass this to BaseInput
        ,
        "aria-controls": this.state.open ? this._id : undefined,
        "aria-expanded": this.state.open ? true : undefined,
        "data-tid": "ba-auto-complete__search-input"
      }, searchInputPassthroughProps, {
        fullWidth: true,
        iconLeft: autocompleteIcon,
        hideLeftIcon: hideLeftIcon,
        onChange: this._onChange,
        onBlur: this._onBlur,
        value: value,
        ref: node => {
          this._input = node;
          if (node) ref((0, _reactDom.findDOMNode)(node));
        },
        onKeyDown: this._onKeyDown
      }));
    });
    (0, _defineProperty2.default)(this, "_parseFilteredValues", values => {
      const objArr = values.map(obj => {
        if (typeof obj === 'string') {
          return {
            label: obj,
            value: obj
          };
        } else if (!obj.value && obj.label) {
          obj.value = obj.label;
        }
        return obj;
      });
      return objArr;
    });
    (0, _defineProperty2.default)(this, "_dropdownRef", node => {
      this._dropdown = node;
    });
    (0, _defineProperty2.default)(this, "_onClose", () => {
      this.setState({
        open: false
      });
    });
    (0, _defineProperty2.default)(this, "_onScrollClose", () => {
      this.setState({
        open: false
      });
    });
    this.state = {
      focusIndex: -1,
      filteredValues: this._filterValues(props),
      value: this._getStringValue(props.value),
      open: false
    };
    this.textDir = props.textDir;
    this._id = uniqueId('__autocompleteinput_');
  }
  componentWillReceiveProps(nextProps) {
    const {
      values
    } = nextProps;
    const value = this._getStringValue(nextProps.value);
    if (value !== '') {
      // Defect 244355: Check when new props values is passed in and open dropdown if there are any matched values.
      const openState = !isEqual(values, this.props.values) ? {
        open: this._hasFilteredValues(value, values)
      } : {};
      // Defect 249963: Update value state only when value props changed
      const newValue = value !== this._getStringValue(this.props.value) ? value : this.state.value;
      if (this.state.focusIndex !== -1) {
        this.setState({
          focusIndex: -1,
          value: newValue,
          filteredValues: this._filterValues(nextProps),
          ...openState
        });
      } else if (this.state.focusIndex === -1) {
        this.setState({
          value: newValue,
          filteredValues: this._filterValues(nextProps),
          ...openState
        });
      }
    } else {
      // reset filtered value list when text input is empty
      // Defect 239844: add value in set state to clear input field whenever empty string is passed to prop.value
      this.setState({
        filteredValues: this._filterValues(nextProps),
        value
      });
    }
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.state.focusIndex !== prevState.focusIndex && this._list) {
      this._list.scrollAround(this.state.focusIndex);
    }
  }
  focus() {
    this._input && this._input.focus();
  }
  _filterValues(_ref) {
    let {
      value = '',
      values = []
    } = _ref;
    const {
      customFilter
    } = this.props;
    let stringValue = this._getStringValue(value);
    if (stringValue === null) {
      stringValue = '';
    }
    if (customFilter) {
      // Story 252514: Add custom filter for server side auto-completion
      return customFilter({
        value: stringValue.trim(),
        values
      });
    } else if (values && values.filter) {
      stringValue = stringValue.trim();
      const filterFn = stringValue.length === 1 && this.props.filterFromStart ? startsWithFilter(stringValue) : containsFilter(stringValue);
      return values.filter(filterFn);
    }
    return [];
  }
  _getStringValue(value) {
    if (typeof value !== 'string' && value !== null) {
      return value.label;
    }
    return value;
  }
  _arrayContainsObj(arr) {
    for (let i = 0; i < arr.length; i++) {
      if (typeof arr[i] === 'object') {
        return true;
      }
    }
    return false;
  }
  _notifyChange(value) {
    this.props.onChange && this.props.onChange(value);
  }
  _hasFilteredValues(value, values) {
    const filteredValues = this._filterValues({
      value,
      values
    });
    if (value.trim().length && filteredValues.length) {
      this.props.onValueMatch && this.props.onValueMatch(filteredValues);
      return true;
    }
    return false;
  }
  _handleKeyEventByList(e) {
    const list = get(this, '_dropdown._list');
    list && list.handleKeyEvent(e);
  }
  render() {
    const {
      id,
      'data-tid': dataTid,
      fullWidth,
      iconLeft,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      hideLeftIcon,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      className,
      style,
      ...others
    } = this.props;
    const {
      filteredValues,
      focusIndex,
      open
    } = this.state;
    const classNames = (0, _utils.classnames)(autoCompleteInputClassName, {
      fullWidth
    });
    const dropdownProps = {
      triggerNodeId: this._id,
      id,
      'data-tid': dataTid || 'ba-auto-complete__search-input',
      ...sanitize(others, AutoCompleteInput),
      triggerNodeRenderer: this._triggerNodeRenderer,
      options: this._parseFilteredValues(filteredValues),
      open,
      className: `${classNames} ${className}`,
      ref: this._dropdownRef,
      focusIndex,
      onClose: this._onClose,
      onActiveChange: this._onActiveChange,
      onChange: this.onSelectionChange,
      onScrollClose: this._onScrollClose,
      truncated: true,
      style
    };
    return /*#__PURE__*/_react.default.createElement(_listdropdown.default, dropdownProps);
  }
}
exports["default"] = AutoCompleteInput;
(0, _defineProperty2.default)(AutoCompleteInput, "propTypes", {
  ..._searchinput.default.propTypes,
  values: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.string), _propTypes.default.arrayOf(_propTypes.default.object)]),
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  loading: _propTypes.default.bool,
  fullWidth: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  onValueMatch: _propTypes.default.func,
  onSelectionChange: _propTypes.default.func,
  onSubmit: _propTypes.default.func,
  onBlur: _propTypes.default.func,
  onKeyDown: _propTypes.default.func,
  collapseExtraOptions: _propTypes.default.object,
  listExtraOptions: _propTypes.default.object,
  progressIndicatorExtraOptions: _propTypes.default.object,
  filterFromStart: _propTypes.default.bool,
  ariaLabel: _propTypes.default.string,
  ariaLabelledBy: _propTypes.default.string,
  customFilter: _propTypes.default.func
});
(0, _defineProperty2.default)(AutoCompleteInput, "defaultProps", {
  ..._searchinput.default.defaultProps,
  filterFromStart: true,
  value: '',
  values: [],
  collapseExtraOptions: {},
  listExtraOptions: {},
  progressIndicatorExtraOptions: {},
  ariaLabel: _StringResource.default.get('autoCompleteSearchInput'),
  ariaLabelledBy: ''
});

/***/ }),

/***/ 603:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
var _AutoCompleteInput = _interopRequireDefault(__webpack_require__(84774));
exports["default"] = _AutoCompleteInput.default;
exports.AutoCompleteInput = _AutoCompleteInput.default;

/***/ }),

/***/ 8796:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = void 0;
var _utils = __webpack_require__(78815);
var _AutoCompleteInputResources = _interopRequireDefault(__webpack_require__(42240));
/* IBM Confidential
*
* OCO Source Materials
*
* IBM Cognos Products: ba-ui-toolkit
* (C) Copyright IBM Corp. 2019
*
* The source code for this program is not published or otherwise
* divested of its trade secrets, irrespective of what has been
* deposited with the U.S. Copyright Office.
* NLS_ENCODING=UTF-8
* NLS_MESSAGEFORMAT_NONE
*/
// eslint-disable-line
var _default = exports["default"] = new _utils.StringResource(_AutoCompleteInputResources.default);

/***/ }),

/***/ 46376:
/***/ ((module, exports, __webpack_require__) => {

exports = module.exports = __webpack_require__(98060)(false);
// imports


// module
exports.push([module.id, ".ba-common-autoCompleteInput{position:relative;display:inline-block}.ba-common-autoCompleteInput.is-fullWidth{display:block}.ba-common-autoCompleteInput.is-fullWidth .ba-common-searchInput{width:100%}", ""]);

// exports
exports.locals = {
	"autoCompleteInputClassName": "\"ba-common-autoCompleteInput\""
};

/***/ }),

/***/ 32498:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93379);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7795);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90569);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3565);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19216);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44589);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_AutoCompleteInput_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(46376);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_AutoCompleteInput_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_AutoCompleteInput_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony reexport (unknown) */ var __WEBPACK_REEXPORT_OBJECT__ = {};
/* harmony reexport (unknown) */ for(const __WEBPACK_IMPORT_KEY__ in _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_AutoCompleteInput_scss__WEBPACK_IMPORTED_MODULE_6__) if(__WEBPACK_IMPORT_KEY__ !== "default") __WEBPACK_REEXPORT_OBJECT__[__WEBPACK_IMPORT_KEY__] = () => _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_AutoCompleteInput_scss__WEBPACK_IMPORTED_MODULE_6__[__WEBPACK_IMPORT_KEY__]
/* harmony reexport (unknown) */ __webpack_require__.d(__webpack_exports__, __WEBPACK_REEXPORT_OBJECT__);

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default());
options.setAttributes = (_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default());

      options.insert = _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default().bind(null, "head");
    
options.domAPI = (_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default());
options.insertStyleElement = (_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default());

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_AutoCompleteInput_scss__WEBPACK_IMPORTED_MODULE_6___default()), options);




       /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_AutoCompleteInput_scss__WEBPACK_IMPORTED_MODULE_6___default()) && (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_AutoCompleteInput_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) ? (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_AutoCompleteInput_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) : undefined);


/***/ }),

/***/ 93379:
/***/ ((module) => {

"use strict";


var stylesInDOM = [];
function getIndexByIdentifier(identifier) {
  var result = -1;
  for (var i = 0; i < stylesInDOM.length; i++) {
    if (stylesInDOM[i].identifier === identifier) {
      result = i;
      break;
    }
  }
  return result;
}
function modulesToDom(list, options) {
  var idCountMap = {};
  var identifiers = [];
  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = options.base ? item[0] + options.base : item[0];
    var count = idCountMap[id] || 0;
    var identifier = "".concat(id, " ").concat(count);
    idCountMap[id] = count + 1;
    var indexByIdentifier = getIndexByIdentifier(identifier);
    var obj = {
      css: item[1],
      media: item[2],
      sourceMap: item[3],
      supports: item[4],
      layer: item[5]
    };
    if (indexByIdentifier !== -1) {
      stylesInDOM[indexByIdentifier].references++;
      stylesInDOM[indexByIdentifier].updater(obj);
    } else {
      var updater = addElementStyle(obj, options);
      options.byIndex = i;
      stylesInDOM.splice(i, 0, {
        identifier: identifier,
        updater: updater,
        references: 1
      });
    }
    identifiers.push(identifier);
  }
  return identifiers;
}
function addElementStyle(obj, options) {
  var api = options.domAPI(options);
  api.update(obj);
  var updater = function updater(newObj) {
    if (newObj) {
      if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap && newObj.supports === obj.supports && newObj.layer === obj.layer) {
        return;
      }
      api.update(obj = newObj);
    } else {
      api.remove();
    }
  };
  return updater;
}
module.exports = function (list, options) {
  options = options || {};
  list = list || [];
  var lastIdentifiers = modulesToDom(list, options);
  return function update(newList) {
    newList = newList || [];
    for (var i = 0; i < lastIdentifiers.length; i++) {
      var identifier = lastIdentifiers[i];
      var index = getIndexByIdentifier(identifier);
      stylesInDOM[index].references--;
    }
    var newLastIdentifiers = modulesToDom(newList, options);
    for (var _i = 0; _i < lastIdentifiers.length; _i++) {
      var _identifier = lastIdentifiers[_i];
      var _index = getIndexByIdentifier(_identifier);
      if (stylesInDOM[_index].references === 0) {
        stylesInDOM[_index].updater();
        stylesInDOM.splice(_index, 1);
      }
    }
    lastIdentifiers = newLastIdentifiers;
  };
};

/***/ }),

/***/ 90569:
/***/ ((module) => {

"use strict";


var memo = {};

/* istanbul ignore next  */
function getTarget(target) {
  if (typeof memo[target] === "undefined") {
    var styleTarget = document.querySelector(target);

    // Special case to return head of iframe instead of iframe itself
    if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
      try {
        // This will throw an exception if access to iframe is blocked
        // due to cross-origin restrictions
        styleTarget = styleTarget.contentDocument.head;
      } catch (e) {
        // istanbul ignore next
        styleTarget = null;
      }
    }
    memo[target] = styleTarget;
  }
  return memo[target];
}

/* istanbul ignore next  */
function insertBySelector(insert, style) {
  var target = getTarget(insert);
  if (!target) {
    throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
  }
  target.appendChild(style);
}
module.exports = insertBySelector;

/***/ }),

/***/ 19216:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function insertStyleElement(options) {
  var element = document.createElement("style");
  options.setAttributes(element, options.attributes);
  options.insert(element, options.options);
  return element;
}
module.exports = insertStyleElement;

/***/ }),

/***/ 3565:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


/* istanbul ignore next  */
function setAttributesWithoutAttributes(styleElement) {
  var nonce =  true ? __webpack_require__.nc : 0;
  if (nonce) {
    styleElement.setAttribute("nonce", nonce);
  }
}
module.exports = setAttributesWithoutAttributes;

/***/ }),

/***/ 7795:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function apply(styleElement, options, obj) {
  var css = "";
  if (obj.supports) {
    css += "@supports (".concat(obj.supports, ") {");
  }
  if (obj.media) {
    css += "@media ".concat(obj.media, " {");
  }
  var needLayer = typeof obj.layer !== "undefined";
  if (needLayer) {
    css += "@layer".concat(obj.layer.length > 0 ? " ".concat(obj.layer) : "", " {");
  }
  css += obj.css;
  if (needLayer) {
    css += "}";
  }
  if (obj.media) {
    css += "}";
  }
  if (obj.supports) {
    css += "}";
  }
  var sourceMap = obj.sourceMap;
  if (sourceMap && typeof btoa !== "undefined") {
    css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
  }

  // For old IE
  /* istanbul ignore if  */
  options.styleTagTransform(css, styleElement, options.options);
}
function removeStyleElement(styleElement) {
  // istanbul ignore if
  if (styleElement.parentNode === null) {
    return false;
  }
  styleElement.parentNode.removeChild(styleElement);
}

/* istanbul ignore next  */
function domAPI(options) {
  if (typeof document === "undefined") {
    return {
      update: function update() {},
      remove: function remove() {}
    };
  }
  var styleElement = options.insertStyleElement(options);
  return {
    update: function update(obj) {
      apply(styleElement, options, obj);
    },
    remove: function remove() {
      removeStyleElement(styleElement);
    }
  };
}
module.exports = domAPI;

/***/ }),

/***/ 44589:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function styleTagTransform(css, styleElement) {
  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css;
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild);
    }
    styleElement.appendChild(document.createTextNode(css));
  }
}
module.exports = styleTagTransform;

/***/ }),

/***/ 68779:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 38213:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 97880:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 98060:
/***/ ((module) => {

"use strict";
module.exports = require("css-loader/lib/css-base");

/***/ }),

/***/ 580:
/***/ ((module) => {

"use strict";
module.exports = require("prop-types");

/***/ }),

/***/ 16689:
/***/ ((module) => {

"use strict";
module.exports = require("react");

/***/ }),

/***/ 66405:
/***/ ((module) => {

"use strict";
module.exports = require("react-dom");

/***/ }),

/***/ 57756:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__57756__;

/***/ }),

/***/ 3142:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__3142__;

/***/ }),

/***/ 16293:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__16293__;

/***/ }),

/***/ 78815:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__78815__;

/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ var __webpack_exports__ = (__webpack_exec__(603));
/******/ return __webpack_exports__;
/******/ }
]);
});